import type { AccountType } from '@dhl/mdp-api'
import { type Account, inverseSelectedProducts } from '~/common/components/accountnumbers'
import type { Product } from '~/common/model/capabilities'
import { BusinessTypeEnum } from '~/api/constants'

export const getInitialAccount = (
  products: Product[],
  countryCode: string,
  organisationId: string,
  businessUnit: string
): Account => ({
  id: '',
  accountType: 'Parcel',
  organisationId,
  countryCode,
  selectedProducts: getInitialSelectedAccountProducts('Parcel', businessUnit, products),
  selectedParcelTypes: [],
  selectedShipmentOptions: [],
  blockedInfo: { isBlocked: false },
  selfOnboardingInfo: undefined,
})

export const getInitialSelectedAccountProducts = (
  accountType: AccountType,
  businessUnit: string,
  products: Product[]
): Product[] =>
  accountType === 'Verlader' || (businessUnit as BusinessTypeEnum) === BusinessTypeEnum.CCC
    ? []
    : // preselects the products that are *not* EPD, EPA, CONNECT-LIGHT or CONNECT-LIGHT-AGGREGATION
      inverseSelectedProducts(
        products.filter(({ value }) => ['EPD', 'EPA', 'CONNECT-LIGHT', 'CONNECT-LIGHT-AGGREGATION'].includes(value)),
        products
      )
